import { Component, OnInit, ViewChild } from '@angular/core';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { PagerserviceService } from "../services/pagerservice.service";
import { NotificationsService } from "angular2-notifications";
import { UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { AdminService } from "../services/admin.service";
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AddEditAdminlist } from '../addeditadminlist/addeditadminlist.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-manageadmin',
    templateUrl: './manageadmin.component.html',
    styleUrls: ['./manageadmin.component.css']
})
export class ManageadminComponent implements OnInit {
    displayedColumns = [
        'name',
        'email',
        'phone',
        'group',
        'status',
        'createdAt',
        'action'
    ];
    public dataSource = new MatTableDataSource();
    pageSize = 25;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    customerList: Array<any>;
    customerFlag = false;
    walletsList: Array<any>;
    walletsres: Array<any>;
    cArr: Array<any>;
    setCustomerList: {};
    customerListById: {};
    /* Pagination fields */
    // pager Number
    pager: number;

    // pager object
    pager1: any = {};
    Tpager: number;
    // paged items
    pagedItems: Array<any>;

    /*Filter variables*/
    serach: string;
    FilPerpage: number;
    FilPage: number;
    customerid = '';

    /* Bank Object */
    banklist = {};
    phonecodelist: Array<any>;

    walletActive: string;
    IPcountry = 'IN';
    phonenumcheck = false;
    currentPag: any = 0;
    /* For Add New Customer Object */
    permission: string;
    totalRecords = 0;
    countries: any[];
    constructor(private userService: UserService,
        private router: Router,
        private notifSer: NotificationsService,
        private spinnerService: Ng4LoadingSpinnerService,
        private pagerService: PagerserviceService,
        private adminService: AdminService,
        private dialog: MatDialog,) { }
    public declarativeFormCaptchaValue: string;
    ngOnInit() {
        // check user is logged or not
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
                var spt = this.router.url.split("/");
                var menu_url = spt[1];
                var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
                var adminrules = JSON.parse(localStorage.getItem('adminrules'));
                var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
                if (index != -1) {
                    var menuid = adminmenus[index]._id;
                    var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
                    this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
                }
            }

            this.walletActive = null;
            this.getAdminUserList();

        }
    }
    addEditAdminlist(element) {
        var new_element = {};
        if (!element) {
            new_element = {
                'name': '',
                'short_name': '',
                'email': '',
                'country': '',
                'gender': '',
                'group': '',
                'phone': '',
                'phonecode': '',
                'mode': 'create',
                '_id': '',
            };
        }
        else {
            new_element = {
                'name': element.name,
                'short_name': element.short_name,
                'email': element.email,
                'country': element.country,
                'gender': element.gender,
                'group': element.group,
                'phone': element.phone,
                'phonecode': element.phonecode,
                'mode': 'edit',
                '_id': element._id,
            };
        }

        const dialogRef = this.dialog.open(AddEditAdminlist, {
            width: '600px',
            data: new_element,
        }).afterClosed().subscribe(result => {
            if (result.success) {
                this.getAdminUserList()
            }
        });
    }
    // For delete users
    deleteCustomer(userId: string) {
        try {
            this.dialog.open(ConfirmationDialogComponent, {
                data: {
                    message: `Are you sure want to  delete customer?`,
                    buttonText: {
                        ok: 'Yes',
                        cancel: 'No'
                    }
                }
            }).afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    const { notif } = defaults;
                    this.userService.customerDelete(userId).subscribe(done => {
                        // this.csrf();
                        this.spinnerService.hide();
                        this.notifSer.success(
                            'Success',
                            'Customer has been deleted', notif
                        )
                        this.getAdminUserList();
                    }, (err) => {
                        this.spinnerService.hide();
                        this.notifSer.error(
                            'Error',
                            err.message, notif
                        )
                    })

                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    // Convert "Active" or "Deactive" to boolean values
    convertStatusToBoolean(status: string): boolean {
        return status === 'Active';
    }

    telInputObject(obj) {
        obj.intlTelInput('setCountry', 'in');
    }

    getAdminUserList() {
        const { notif } = defaults;
        this.spinnerService.show();
        this.adminService.getadminusersList().subscribe(list => {
            if (list.status) {
                // this.actionEditPerformed = false;
                this.dataSource = new MatTableDataSource(list.customers);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.customerList = list.customers;
                // this.Tpager = list.pages;
                // this.currentPag = list.current
                // this.setPage(this.FilPage);
            }
            this.customerFlag = true;
            this.totalRecords = list.total;
            this.spinnerService.hide();
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                err.error.message,
                notif
            )
        })
    }
    /* Pagination of customer details */
    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.getAdminUserList();
    }

    /* Serach Event */
    sreach(event: any) {
        this.serach = event.target.value;
        this.getAdminUserList();
    }

    customerActivate(customer) {
        const { notif } = defaults;
        customer.status = 'Active';

        this.spinnerService.show();
        this.userService.csrf().subscribe(user => {
            customer['_csrf'] = user._csrf;
            this.userService.setActiveLatest(customer).subscribe(done => {
                this.getAdminUserList();
                this.spinnerService.hide();
                this.notifSer.success(
                    'Success',
                    done.message,
                    notif
                )
            }, (err) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Error',
                    err.message,
                    notif
                )
            })
        });

    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    customerDeactivate(customer) {
        const { notif } = defaults;
        customer.status = 'Deactive';
        this.spinnerService.show();
        this.userService.csrf().subscribe(user => {
            customer['_csrf'] = user._csrf;
            this.userService.setActiveLatest(customer).subscribe(done => {
                this.getAdminUserList();
                this.spinnerService.hide();
                this.notifSer.success(
                    'Success',
                    done.message,
                    notif
                )
            }, (err) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Error',
                    err.message,
                    notif
                )

            })
        });

    }
    delete(userId) {
        const { notif } = defaults;
        if (window.confirm('Are you sure want to delete this admin ?')) {
            this.spinnerService.show();
            this.userService.customerDelete(userId).subscribe(done => {
                this.getAdminUserList();
                this.spinnerService.hide();
                this.notifSer.success(
                    'Success',
                    'Admin has been deleted',
                    notif
                )
            }, (err) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Error',
                    err.message,
                    notif
                )
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/manageadmin/manageadmin.component.ts